import { render } from "./RegionKyzylorda.vue?vue&type=template&id=8e30e510&ts=true"
import script from "./RegionKyzylorda.vue?vue&type=script&lang=ts"
export * from "./RegionKyzylorda.vue?vue&type=script&lang=ts"

import "./RegionKyzylorda.vue?vue&type=style&index=0&id=8e30e510&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__